import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_AddNewCustomer = _resolveComponent("AddNewCustomer")!
  const _component_RealEstateCustomers = _resolveComponent("RealEstateCustomers")!
  const _component_AddNewCustomerModal = _resolveComponent("AddNewCustomerModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: "Customers",
      subTitle: "Real Estate"
    }),
    _createVNode(_component_AddNewCustomer),
    _createVNode(_component_RealEstateCustomers),
    _createVNode(_component_AddNewCustomerModal)
  ]))
}